export const ACCOUNT_PERMISSIONS = {
  create: 'organisations.create',
} as const;
